/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

export type ComponentFilterData = {
	self: string;
	id: string;
	name: string;
	description: string;
	lead: {
		self: string;
		accountId: string;
		avatarUrls: {
			'48x48': string;
			'24x24': string;
			'16x16': string;
			'32x32': string;
		};
		displayName: string;
		active: boolean;
	};
	assigneeType: string;
	realAssigneeType: string;
	isAssigneeTypeValid: boolean;
	project: string;
	projectId: number;
}[];

export const componentFilterResource: RouteResource<ComponentFilterData> =
	createResource<ComponentFilterData>({
		type: 'ESCALATIONS_COMPONENT_FILTER_RESOURCE',
		getKey: ({ match }) => getProjectKeyOrId(match),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "escalations/component-filter-resource", jiraSpaEntry: "escalations/component-filter-resource" */ './getData.tsx'
			),
	});

export const useComponentFilterResource = (): UseResourceHookResponse<ComponentFilterData> =>
	useResource<ComponentFilterData>(componentFilterResource);
